<div class="time-picker-time-zone-picker-wrap">
  <div class="time-zone-header" (click)="$event.preventDefault(); $event.stopPropagation()">
    <rt-form-field>
      <rt-input
        #searchInput
        [autoFocus]="true"
        [hasClearButton]="!isEmpty"
        (input)="onInputChange($event)"
        (click)="$event.preventDefault()"
        (reset)="clearField()"
        variant="rounded"
        placeholder="{{ 'rtu.time_zone.search_placeholder' | translate }}"
      >
        <rt-icon prefix name="search" />
      </rt-input>
    </rt-form-field>
  </div>
  <div class="zones-list-container">
    @for (zone of filteredZones; track trackByZone($index, zone)) {
      <rt-dropdown-item (click)="zoneSelect.emit(zone.timezone)" class="zone-item clickable">
        {{ zone.timezoneFormatted }}
      </rt-dropdown-item>
    }
    @if (!filteredZones.length) {
      <rt-dropdown-item class="zone-item">
        {{ 'rtu.ui.select.no_results' | translate }}
      </rt-dropdown-item>
    }
  </div>
</div>
